import React, { useState } from "react";
import { createContext } from "react";
import Cookies from "universal-cookie";

export const AuthContext = createContext();
export default function AuthProvider({ children }) {
  const [userData, setUserData] = useState({
    fname: "",
    lname: "",
    email: "",
    password: "",
  });

  const [filledState, setFilledState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const cookies = new Cookies();
  // const initialUserToken = cookies.get("strandz-user-token") || null;
  const initialTokenId = cookies.get("strandz-user-tokenID") || null;

  const [tokenID, setTokenID] = useState(initialTokenId);
  const [shouldReload, setShouldReload] = useState(false);

  React.useEffect(() => {
    if (shouldReload) {
      setShouldReload(false); // Reset shouldReload once the page reloads
      window.location.reload();
    }
  }, [shouldReload]);

  const loginUser = (uid, email, firstname, lastname, role) => {
    // setToken(newToken);
    const newToken = { uid, email, firstname, lastname, role };

    // Save the token to local storage
    localStorage.setItem("user", JSON.stringify(newToken));

    cookies.set("strandz-user-token", email, { path: "/" });
  };

  const userUID = (newToken) => {
    setTokenID(newToken);
    cookies.set("strandz-user-tokenID", newToken, { path: "/" });
  };

  const logoutUser = () => {
    setTokenID(null);
    cookies.remove("strandz-user-token");
    cookies.remove("strandz-user-tokenID");

    // Clear cart data from localStorage
    localStorage.removeItem("user");

    // setShouldReload(true);
  };

  // React.useEffect(() => {
  //   loginUser();
  //   userUID();
  // }, []);

  const isAuthenticated = !!tokenID || !!localStorage.getItem("user");

  return (
    <AuthContext.Provider
      value={{
        userData,
        setUserData,
        filledState,
        setFilledState,
        isLoading,
        setIsLoading,
        loginUser,
        userUID,
        logoutUser,
        isAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
